<template>
    <div id="main">
        <div class="page">
            <div class="tipos-servicos vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('agro-sugestao') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('agro') }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t('agro-sugestao') }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="!usuarioIntegracao && permissao.create"
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'agro-sugestao-new' })"
                        >
                            {{ $t('adicionar') }}
                        </button>
                    </div>
                </div>

                <div class="columns">
                    <div class="column is-3">
                        <search-bar :onSearch="debouncedOnSearch" />
                    </div>
                    <div class="column is-4">
                        <vss-select
                            ref="origem"
                            :id="generateId(1)"
                            title="tipo-sugestao"
                            :searchable="false"
                            placeholder="todos"
                            v-model="origemSelected"
                            :mlLabels="true"
                            :options="origemSelect"
                            :loading="origemLoading"
                            @input="carregarDados()"
                            class="no-clear"
                            :height="40"
                            clearable
                        />
                    </div>
                    <div class="column is-3">
                        <vss-select
                            :id="generateId(3)"
                            ref="usuarioSelected"
                            title="colaborador"
                            label="label"
                            placeholder="todos"
                            @input="carregarDados()"
                            :options="usuarioSelect"
                            v-model="usuarioSelected"
                            :height="40"
                            clearable
                        />
                    </div>
                    <div class="column is-2">
                        <vss-select
                            :id="generateId(2)"
                            ref="situacaoInput"
                            title="situacao"
                            :options="situacaoSelect"
                            :mlLabels="true"
                            @input="onSituacaoChanged"
                            v-model="situacaoSelected"
                            :height="40"
                            :clearable="true"
                        />
                    </div>
                </div>

                <div class="registry-wrapper">
                    <container-loader v-if="isLoading && !$store.getters.isLoading" />
                    <empty-table-message v-if="isEmpty" />
                    <b-table
                        v-else
                        :data="sugestoes"
                        class="data-table"
                        @sort="sortTable"
                        backend-sorting
                    >
                        <b-table-column
                            v-for="(f, i) in fields"
                            :key="i"
                            :field="f.key"
                            :label="f.key != 'excluir' ? $t(f.key) : ''"
                            :width="f.width"
                            :class="{
                                'excluir-field': f.key == 'excluir',
                            }"
                            :sortable="f.sortable"
                            :custom-sort="f.sortFn"
                            v-slot="props"
                        >
                            <div v-if="f.key == 'descricao'">
                                <router-link
                                    :to="{
                                        name: 'agro-sugestao-edit',
                                        params: { id: props.row.uuid },
                                    }"
                                >
                                    {{
                                        isNull(props.row[f.key])
                                            ? '---'
                                            : cutString(props.row[f.key], 100)
                                    }}
                                </router-link>
                            </div>
                            <div v-else-if="f.key == 'tipo-sugestao'">
                                {{ $t(props.row[f.key].toLocaleLowerCase()) }}
                            </div>
                            <div v-else-if="f.key == 'colaborador'">
                                {{ isNull(props.row[f.key]) ? $t('todos') : props.row[f.key] }}
                            </div>
                            <div v-else-if="f.key == 'excluir'">
                                <span v-if="permissao.delete && !usuarioIntegracao">
                                    <b-button
                                        class="action-button"
                                        :type="
                                            props.row['situacao'] == 1 ? 'is-danger' : 'is-success'
                                        "
                                        :icon-right="
                                            props.row['situacao'] == 1 ? 'delete' : 'check'
                                        "
                                        @click="promptChangeSituacao(props.row)"
                                        v-tippy
                                        :title="
                                            $t(
                                                props.row['situacao'] == 1
                                                    ? 'desativar'
                                                    : 'reativar'
                                            )
                                        "
                                    />
                                </span>
                            </div>
                            <div v-else-if="f.key == 'situacao'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-if="props.row[f.key] == 1"
                                    type="is-success"
                                    size="is-medium"
                                    >{{ $t('ativo') }}</b-tag
                                >
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    v-else
                                    type="is-danger"
                                    size="is-medium"
                                    >{{ $t('inativo') }}</b-tag
                                >
                            </div>
                            <div v-else>
                                {{ props.row[f.key] }}
                            </div>
                        </b-table-column>
                    </b-table>
                    <PaginationViewer
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContainerLoader from '@/components/content/loader/ContainerLoader';
//Service
import sugestaoService from '@/services/agro/SugestaoService';
import ColaboradorService from '@/services/ColaboradorService';

export default {
    components: {
        ContainerLoader,
    },
    data() {
        return {
            usuarioIntegracao: this.$store.state.user.tabelasERPWebServer.includes('SUGESTAO'),
            sugestoes: [],
            situacaoSelect: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacaoSelected: { id: 2, label: 'todos' },
            serviceUsuario: new ColaboradorService(this.$http, this.$router),
            service: new sugestaoService(this.$http, this.$router),
            fields: [
                { key: 'codigo', width: 55, sortable: false, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                {
                    key: 'tipo-sugestao',
                    width: null,
                    sortable: true,
                    sortFn: null,
                    mlLabels: true,
                },
                { key: 'colaborador', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 70, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            permissao: {},
            showUsuarios: false,
            usuarioSelected: { label: 'Todos', id: 0 },
            usuarioSelect: [{ label: 'Todos', id: 0 }],
            usuariosLoading: false,
            origemSelect: [],
            origemSelected: null,
            origemLoading: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-sugestao');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-sugestao' },
            });
            this.startVendedores();
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarDados();
            this.filtroColaboradores();
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;

            //compara caso o objeto nao tenha sido montado ainda ele trata como 0
            let params = [
                this.queryFilter != '' ? this.queryFilter : '.*',
                this.usuarioSelected == 'Todos' ? 0 : this.usuarioSelected.id,
                this.origemSelected == null ? '' : this.origemSelected.label.toLocaleUpperCase(),
            ]; //filtro para tipo(origem) e filtro de usuario

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.sugestoes = value;
                    this.isEmpty = this.sugestoes.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os acertos.');
                })
                .finally((_) => {
                    this.loadOrigem();

                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.idsugestaoconteudo,
                    codigo: m.idsugestaoconteudoerp,
                    descricao: m.descricao,
                    'tipo-sugestao': m.origem,
                    colaborador: m.usuario.nome,
                    idusuario: m.usuario.id,
                    situacao: m.situacao,
                    excluir: 'excluir',
                    uuid: m.uuid,
                };
            });
        },
        loadOrigem() {
            this.origemLoading = true;

            this.service
                .findAllOrigens()
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `Erro com status ${r.status} ao realizar pesquisa por origens.`
                        );
                        this.origemSelect = [];
                    } else {
                        this.origemSelect = r.content.map((v, i) => {
                            return { id: i, label: v.toLocaleLowerCase() };
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por origens.`, e);
                    this.origemSelect = [];
                })
                .finally(() => {
                    this.origemLoading = false;
                });
        },
        filtroColaboradores() {
            this.service
                .filtroColaboradores()
                .then((body) => {
                    if (body.content != null) {
                        return body.content.map((m) => {
                            return { id: m.usuario.idusuario, label: m.usuario.nome };
                        });
                    } else {
                        return null;
                    }
                })
                .then((res) => {
                    if (res != null) this.usuarioSelect.push(...res);
                })
                .catch(console.error);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                row.situacao == 1
                    ? 'msg-confirmacao-desativacao-n'
                    : 'msg-confirmacao-reativacao-n', 
                { n: row.descricao }
            );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-desativar-agro-sugestao'
                    : 'msg-erro-ao-reativar-agro-sugestao';

            let tempsugestao = {
                idsugestaoconteudo: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;

            this.service
                .updateSituacao(tempsugestao)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-agro-sugestao'
                                : 'msg-sucesso-ao-desativar-agro-sugestao';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .table-tag {
            width: 5rem !important;
        }
    }
}
</style>
